/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SAMLChallengeOptions
 */
export interface SAMLChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof SAMLChallengeOptions
     */
    start_authentication_url: string;
}

/**
 * Check if a given object implements the SAMLChallengeOptions interface.
 */
export function instanceOfSAMLChallengeOptions(value: object): value is SAMLChallengeOptions {
    if (!('start_authentication_url' in value) || value['start_authentication_url'] === undefined) return false;
    return true;
}

export function SAMLChallengeOptionsFromJSON(json: any): SAMLChallengeOptions {
    return SAMLChallengeOptionsFromJSONTyped(json, false);
}

export function SAMLChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAMLChallengeOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'start_authentication_url': json['start_authentication_url'],
    };
}

export function SAMLChallengeOptionsToJSON(json: any): SAMLChallengeOptions {
    return SAMLChallengeOptionsToJSONTyped(json, false);
}

export function SAMLChallengeOptionsToJSONTyped(value?: SAMLChallengeOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start_authentication_url': value['start_authentication_url'],
    };
}

